import { createAction } from 'redux-actions';
import { authUpload } from '../AuthFetch';

export const uploadChipData = (uploadFile) => (
  (dispatch) => {
    let formData = new FormData();
    formData.append('uploadfile', uploadFile);

    dispatch({
      type: 'BEFORE_UPLOAD_CHIP_DATA'
    });

    let url = '/firefighter/chip/uploadFile';
    authUpload('POST', url, formData, (json) => {
      dispatch({
        type: 'AFTER_UPLOAD_CHIP_DATA',
        payload: json
      });
    });
  }
);

export const cleanChipDataAlert = createAction('CLEAN_CHIP_DATA_ALERT');



// WEBPACK FOOTER //
// ./src/actions/chipUploadActions.js